export const getTopicsOptions = (departments) =>
	departments?.reduce((acc, next) => {
		acc.push(...(next.topics || []));
		return acc;
	}, []);
